import { c as _c } from "react/compiler-runtime";
import WorldActionButtons from '@/app/[locale]/(worlds)/[roomId]/components/WorldActionButtons';
import WorldLabels from '@/app/[locale]/(worlds)/[roomId]/components/WorldLabels';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { cn } from '@/lib/utils';
import { RefObject, useRef, useState } from 'react';
import { useResizeObserver } from 'usehooks-ts';
function WorldInfoTitle() {
  const $ = _c(37);
  const titleRef = useRef(null);
  const scaledTitleRef = useRef(null);
  const {
    is3DCommerce
  } = useWorldDetailsContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const {
    isMobileLandscape,
    isMobile
  } = useUAContext();
  const lineHeight = isMobile ? 26 : 32;
  const maxFontSize = isMobile ? 18 : 24;
  const [isOverflow, setIsOverflow] = useState(false);
  const [fontSize, setFontSize] = useState(maxFontSize);
  let t0;
  if ($[0] !== lineHeight) {
    t0 = {
      ref: titleRef as RefObject<HTMLElement>,
      onResize: () => {
        if (!titleRef.current) {
          return;
        }
        const el = titleRef.current;
        const lines = Math.round(el.scrollHeight / lineHeight);
        setIsOverflow(lines > 3);
      }
    };
    $[0] = lineHeight;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useResizeObserver(t0);
  let t1;
  if ($[2] !== lineHeight || $[3] !== maxFontSize) {
    t1 = {
      ref: scaledTitleRef as RefObject<HTMLElement>,
      onResize: () => {
        if (!scaledTitleRef.current) {
          return;
        }
        const el_0 = scaledTitleRef.current;
        const maxHeight = lineHeight * 3;
        let scale = 1;
        el_0.style.fontSize = `${maxFontSize}px`;
        el_0.style.lineHeight = `${lineHeight}px`;
        while (el_0.scrollHeight > maxHeight && maxFontSize * scale > 8) {
          scale = scale * 0.95;
          el_0.style.fontSize = `${maxFontSize * scale}px`;
        }
        setFontSize(maxFontSize * scale);
      }
    };
    $[2] = lineHeight;
    $[3] = maxFontSize;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useResizeObserver(t1);
  let t2;
  if ($[5] !== isOverflow) {
    t2 = cn("flex justify-between gap-4", {
      "pointer-events-none invisible absolute": isOverflow
    });
    $[5] = isOverflow;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isMobileLandscape) {
    t3 = cn("flex items-center gap-2 overflow-hidden text-lg leading-6.5 font-extrabold tracking-[0.1px] break-all max-md:flex-1 md:text-2xl md:leading-8", {
      "md:text-lg md:leading-6.5": isMobileLandscape
    });
    $[7] = isMobileLandscape;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== is3DCommerce) {
    t4 = is3DCommerce && <WorldLabels />;
    $[9] = is3DCommerce;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== roomData.title || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="flex flex-col"><h2 ref={titleRef} className={t3}>{roomData.title}{t4}</h2></div>;
    $[11] = roomData.title;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <WorldActionButtons />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t5) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = !isOverflow;
  let t9;
  if ($[19] !== t8) {
    t9 = cn({
      hidden: t8
    });
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = `${fontSize}px`;
  const t11 = `${lineHeight}px`;
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = {
      fontSize: t10,
      lineHeight: t11
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== is3DCommerce) {
    t13 = is3DCommerce && <WorldLabels />;
    $[24] = is3DCommerce;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== roomData.title || $[27] !== t12 || $[28] !== t13) {
    t14 = <h2 ref={scaledTitleRef} className="flex items-center gap-2 font-extrabold tracking-[0.1px] break-all max-md:flex-1" style={t12}>{roomData.title}{t13}</h2>;
    $[26] = roomData.title;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className={cn("mt-2 flex items-start justify-between")}><WorldActionButtons /></div>;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t9) {
    t16 = <div className={t9}>{t14}{t15}</div>;
    $[31] = t14;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16 || $[35] !== t7) {
    t17 = <div className="relative" data-component="world-info-title">{t7}{t16}</div>;
    $[34] = t16;
    $[35] = t7;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
export default WorldInfoTitle;